import React, { Component } from 'react'
import { Table } from "antd"
import { observer, inject } from 'mobx-react'

@inject("store") @observer
export default class DataTable extends Component {
  componentDidMount() {
    const { store: { list } } = this.props
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list,
      },
    } = this.props
    list.changePagin(selectedPageNumber)
    document.getElementById('contentTop').scrollIntoView(true)
  }

  render() {
    const {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        }
      }
    } = this.props

    const columns = [
      {
        title: "用户名",
        className: "ta-l",
        dataIndex: "ownerName",
        width: 120,
        fixed: 'left',
      }, {
        title: "任务id",
        className: "ta-l",
        dataIndex: "taskId",
        width: 250,
        fixed: 'left',
      }, {
        title: "报告备注",
        className: "ta-l",
        dataIndex: "remark",
        width: 130,
        fixed: 'left',
        render: (text) => {
          return (
            <span>{text || '-'}</span>
          )
        }
      }, {
        title: "家系名称",
        className: "ta-l",
        dataIndex: "groupName",
        width: 200,
        fixed: 'left',
      },
      {
        title: "创建时间",
        className: "ta-l",
        dataIndex: "createTime",
        width: 150
      },
      {
        title: "引物",
        className: "ta-l",
        dataIndex: "primer",
        width: 300
      },
      {
        title: "编号",
        className: "ta-l",
        dataIndex: "sampleIndex",
        width: 150
      },
      {
        title: "样本名称",
        className: "ta-l",
        dataIndex: "sampleName",
        width: 150
      }, {
        title: "上传时间",
        className: "ta-l",
        dataIndex: "uploadTime",
        width: 150
      },
      {
        title: "性别",
        className: "ta-l",
        dataIndex: "sex",
        width: 150
      },
      {
        title: "家系关系",
        className: "ta-l",
        dataIndex: "relationName",
        width: 150
      },
      {
        title: "致病性",
        className: "ta-l",
        dataIndex: "pathogen",
        width: 200
      },
      {
        title: "Total Reads",
        className: "ta-l",
        dataIndex: "totalReads",
        width: 150
      },
      {
        title: "High_Q_Ratio",
        className: "ta-l",
        dataIndex: "highQRatio",
        width: 150
      },
      {
        title: "Map_Ratio",
        className: "ta-l",
        dataIndex: "mapRatio",
        width: 150
      },
      {
        title: "Target_Ratio",
        className: "ta-l",
        dataIndex: "targetRatio",
        width: 150
      },
      {
        title: "Target_Depth",
        className: "ta-l",
        dataIndex: "targetDepth",
        width: 150
      },
      {
        title: "Target_Coverage",
        className: "ta-l",
        dataIndex: "targetCoverage",
        width: 150
      },
      {
        title: "Target_Cover_30X",
        className: "ta-l",
        dataIndex: "targetCover30X",
        width: 150
      },
      {
        title: "Target_Cover_50X",
        className: "ta-l",
        dataIndex: "targetCover50X",
        width: 150
      },
      {
        title: "Target_Cover_100X",
        className: "ta-l",
        dataIndex: "targetCover100X",
        width: 150
      },
      {
        title: "pass",
        className: "ta-l",
        dataIndex: "pass",
        width: 150
      },
      {
        title: "report_chr",
        className: "ta-l",
        dataIndex: "reportChr",
        width: 150
      },
      {
        title: "haplo_type",
        className: "ta-l",
        dataIndex: "haplotype",
        width: 150
      },
      {
        title: "M",
        className: "ta-l",
        dataIndex: "maternalBefore2m",
        width: 80,
      },
      {
        title: "P",
        className: "ta-l",
        dataIndex: "paternalBefore2m",
        width: 80,
      },
      {
        title: "M",
        className: "ta-l",
        dataIndex: "maternalBefore1m",
        width: 80,
      },
      {
        title: "P",
        className: "ta-l",
        dataIndex: "paternalBefore1m",
        width: 80,
      }, {
        title: "M",
        className: "ta-l",
        dataIndex: "maternal",
        width: 80,
      }, {
        title: "P",
        className: "ta-l",
        dataIndex: "paternal",
        width: 80,
      },
      {
        title: "M",
        className: "ta-l",
        dataIndex: "maternalAfter1m",
        width: 80,
      }, {
        title: "P",
        className: "ta-l",
        dataIndex: "paternalAfter1m",
        width: 80,
      }, {
        title: "M",
        className: "ta-l",
        dataIndex: "maternalAfter2m",
        width: 80,
      }, {
        title: "P",
        className: "ta-l",
        dataIndex: "paternalAfter2m",
        width: 80,
      }
    ]

    return (
      <div className="wrapper-box" >
        <Table
          scroll={{ x: 4750 }}
          columns={columns}
          dataSource={tableData.slice()}
          rowKey={(record, index) => record.reportId + index}
          pagination={{
            pageSize: queryMap.limit,
            onChange: this.onPaginChange,
            defaultCurrent: 1,
            current: currentPageIndex,
            total: totalCount,
          }}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/research/pgd/statistics/containers/DataTable.js